import { render } from "./pending.vue?vue&type=template&id=33d90ddc&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"

import "./pending.vue?vue&type=style&index=0&id=33d90ddc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d90ddc"]])

export default __exports__